import Vue from 'vue'
import App from './App.vue'


import axios from 'axios'
import Vuex from 'vuex'


import router from './router'
// import store from './store'
// import './permission'

Vue.config.productionTip = false
import echarts from 'echarts'
import 'echarts-liquidfill'

import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(Vuex);


import '../src/assets/font_c77c5cghp4/iconfont.css'
import '../src/assets/css/main.css'
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios;
// axios.defaults.baseURL = '/api'; //解决跨域的关键代码
axios.defaults.withCredentials = true;

// axios.interceptors.request.use(function (config) {
//   if (store.getters.isLogin) {
//     return config;
//   }

// }, function (err) {
//   return Promise.reject(err);
// });



new Vue({
  router,
  // store,
  render: h => h(App),
}).$mount('#app')